// React
import { useState, useEffect, useCallback } from 'react';
import { callBackend } from './api.js';

// Amplify UI
import '@aws-amplify/ui-react/styles.css';
import {
    Button,
    Label,
    Divider,
    Flex,
    Heading,
    Table,
    TableHead,
    TableBody,
    TableRow,
    TableCell,
    Card,
    Input,
    Link
} from '@aws-amplify/ui-react';
import './HistoryTable.css';

export default function HistoryTable({
    selectedExercise, closeFn, setMustSave, setMustClose, setCurrentExercise, restartKey, setRestartKey
}) {
    const [history, setHistory] = useState(blankHistory());
    const [updating, setUpdating] = useState(false);
    
    const populateHistory = useCallback(async () => {
        getHistory();
    }, [selectedExercise]);

    async function getHistory() {
        if (selectedExercise === "") {
            setHistory(blankHistory());
            setRestartKey("");
        } else {
            const myInit = {
                exercise_name: selectedExercise,
                restartKey: restartKey
            };

            try {
                const apiResultRaw = await callBackend("workouts", "GET", myInit);
                
                const apiResult = (await apiResultRaw);
                if (restartKey === "") {
                    setHistory(apiResult);
                } else {
                    const items = [history.history, apiResult.history].flat().filter(i => i !== undefined && i !== null);
                    setHistory({...history, history: items, name: apiResult.name, body_part: apiResult.body_part, settings: apiResult.settings});
                }
                setRestartKey(apiResult.restartKey ? apiResult.restartKey : "");
                console.log('restartKey: ', apiResult.restartKey);
            } catch (e) {
                alert(`Error refreshing transactions: ${e}`);
            }
        }
    }

    async function updateExercise() {
        //setIsRefreshing(true); 
        const path = 'workouts';
        console.log('in updating exercise:'+ selectedExercise + ":" + history.settings);
        const myInit = {
            body: {
                action: "updateExercise",
                exercise: selectedExercise,
                setting: history.settings
            },
        };

        try {
            const apiResult = await callBackend(path, "PUT", myInit);
            setUpdating(false);
        } catch (e) {
            alert(`Error refreshing workouts: ${e}`);
        }
    }

    function updateSettings(newValue) {
        var toUpdate = history;

        toUpdate = {...history, settings: newValue};
        
        setHistory(toUpdate);
    }

    useEffect(() => {
        //console.log('in useEffect', dayOfWeek);
        populateHistory();
    }, [populateHistory, selectedExercise]);


    function resetHistory() {
        setMustSave();
        setHistory(blankHistory());
        setRestartKey("");
        setMustClose(true);
        closeFn();
    }

    function blankHistory () {
        var histDict = {
            "name": "", 
            "body_part": "", 
            "settings": "", 
            "history": []
        };
        return histDict;
    }

    // Return table rows of instances
    function HistoryRows() {
        return history.history && history.history.map((i,j) => {
            return (
                <TableRow key={j}>
                    <TableCell className="history-cells">
                        <Link
                            onClick={() => {
                                setCurrentExercise({...i, ts: i.when});
                            }}
                            style={{ marginLeft: '10px' }}
                        >
                            {i.date}
                        </Link>
                    </TableCell>
                    <TableCell className="history-cells">{i.details}</TableCell>
                    <TableCell className="history-cells">{i.order}</TableCell>
                    <SetDetails 
                        historyItem={i.sets}
                    /> 
                </TableRow>
            );
        });
    }

    function SetDetails(historyItem) {
        return historyItem["historyItem"].map((j, i) => {
            var sore = j.sore ? 's' : '';
            var cheat = j.cheat ? '*' : '';
                
            return (
                <TableCell className="history-cells-sets" key={i}>{j.weight} x {j.reps} {sore} {cheat}</TableCell>
            );
        });
    }

    return (
        selectedExercise && selectedExercise != "" &&
        
        <Card direction="column" alignContent="center">
            <Divider orientation="horizontal" />
            <Flex justifyContent="center">
                <Heading level="3">
                    History records for <br />{history.name}
                </Heading>
            </Flex>
            <Flex direction={'column'} textAlign={'center'}>
                <Card textAlign={'center'}>
                    <Label>Body part: {history.body_part}</Label>
                </Card>
                { (!updating) ? 
                    <Card textAlign={'center'}>
                        <Label>Settings: {history.settings}</Label>
                        <Link
                            onClick={() => setUpdating(true)}
                        >
                            &nbsp;&nbsp;update
                        </Link>
                    </Card>
                :
                    <Card textAlign={'center'}>
                        <Input value={history.settings} 
                            onChange={(event) => {
                                updateSettings(event.target.value);
                            }}
                        />
                        <Button 
                            onClick={() => updateExercise(history.settings)}
                        >
                            Update
                        </Button>
                    </Card>     
                }
            </Flex>
            <Table highlightOnHover={true} variation="striped">
                <TableHead>
                    <TableRow>
                        <TableCell className="history-cells" as="th">Date</TableCell>
                        <TableCell className="history-cells" as="th">Settings</TableCell>
                        <TableCell className="history-cells" as="th">Order</TableCell>
                        <TableCell className="history-cells" as="th">Set 1</TableCell>
                        <TableCell className="history-cells" as="th">Set 2</TableCell>
                        <TableCell className="history-cells" as="th">Set 3</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    <HistoryRows />
                </TableBody>
            </Table>
            <Flex justifyContent="center">
                <Button
                    onClick={() => resetHistory()}
                    style={{ marginLeft: '20px' }}
                >
                    Close
                </Button>
                { restartKey && 
                    <Button
                        onClick={() => getHistory()}
                        style={{ marginLeft: '20px' }}
                    >
                        Load More
                    </Button>
                }
            </Flex>
            <Divider orientation="horizontal" />
        </Card>
    );
}
